import React from 'react';
import { Dropdown, Header, Message } from 'semantic-ui-react'
import { setCompanyClaimOption, setClaimantClaimOption } from '../../../../actions'

const FormsInputsDropdown = (props) => {

    // console.log(field.value);

    const {field, form} = props; 
    var removeSelectedInitial = true
    if (field.name === 'paymentMethod' && props.initialVal) removeSelectedInitial = props.initialVal !== field.value 

    const handleChange = (e, {value}) => {
        if (props.onChange){
            if (field.name=='benefitGroupItem'){
                form.setFieldValue(field.name, value)   
                props.options.forEach(option=>{   
                    if (option.value === value || option.id == value){   
                        form.setFieldValue('showDiagnosis', option.sd)
                    }  
                })  
                props.onChange(value)   
            } else {
                props.onChange()
            }

        } else { 
            if(field.name=='companyId'){
                setCompanyClaimOption(value)
                setClaimantClaimOption(form.initialValues['claimantId'])
                form.setFieldValue('claimantId', form.initialValues['claimantId'])
            }
            if(field.name=='claimantId'){
                setClaimantClaimOption(value)
            } 

            form.setFieldValue(field.name, value) 
        }
        
    }  

    return (
        <div className="field">
            <>
                <Header as='h5'>{props.label}</Header>
                {(props.secondaryLabel) ? <Header.Subheader>{props.secondaryLabel}</Header.Subheader>: ''}
            </>
            <Dropdown
                fluid
                selection
                options={props.options}
                onChange={handleChange} 
                value={field.value}
                disabled={(props.disabled) ? props.disabled : false}
                text={!removeSelectedInitial ? props.initialVal : ""} //use text if field is paymentMethod & paymentMethod not in option because value has to be in option
            />
            {
                    (props.form.errors[props.field.name]) &&
                    (
                        <Message negative>
                            {props.form.errors[props.field.name]}
                        </Message>
                    )
                }
        </div>
    );
}

export default FormsInputsDropdown;

// friendOptions = [
//   {
//     text: 'Jenny Hess',
//     value: 'Jenny Hess',
//     image: { avatar: true, src: '/images/avatar/small/jenny.jpg' },
//   },
//  ...
// ]
